import {put, call} from "redux-saga/effects";
import {getErrorFromMessage} from "services/utils/utils";
import {errorAssociateCompany, successAssociateCompany} from "features/modals/company/associate/reducer";
import * as api from "services/api";

export function* associateCompanySaga({payload}) {
    try {
        yield call([api, api.associateCompany], payload.companyName, payload.secretCode, payload.role);
        yield put(successAssociateCompany());
    } catch (e) {
        yield put(errorAssociateCompany(getErrorFromMessage(e)))
    }
}